import { gql } from '@apollo/client';

export const ASSET_FRAGMENT = gql
`
    fragment AssetFragment on uploads_Asset
    {
        id
        focalPoint
        url
        height
        width
        title
        caption
        assetLinkUrl
        attribution
    }
`;

export const BODY_CONTENT_FRAGMENT = gql
`
    fragment BodyContentFragment on bodyContent_MatrixField {
  ... on videoGroup_Entry {
    id
    typeHandle
    videoThumbnail {
      ...AssetFragment
    }
    video {
      title
      url
      aspectRatio
    }
  }
  ... on textPanel_Entry {
    id
    typeHandle
    heading
    subHeading
    summary
    body
    textPanelConfig
  }
  ... on relatedTeamMembers_Entry {
    id
    headline
    typeHandle
    featuredTeamMembers {
      ... on staff_Entry {
        title
        displayTitle
        position
        slug
        uri
        featureImage {
          ...AssetFragment
        }
        bodyContent {
          __typename
        }
      }
      url
    }
  }
  ... on relatedProjects_Entry {
    id
    headline
    typeHandle
    project {
      ... on projects_Entry {
        displayTitle
        title
        summary
        uri
        featureImage {
          ...AssetFragment
        }
        url
      }
    }
  }
  ... on latestProjects_Entry {
    id
    headline
    typeHandle
  }
  ... on relatedNews_Entry {
    id
    typeHandle
    headline
    featuredNewsEntries {
      ... on news_Entry {
        slug
        uri
        displayTitle
        summary
        featureImage {
          ...AssetFragment
        }
      }
      ... on newsletters_Entry {
        slug
        uri
        displayTitle
        summary
        featureImage {
          ...AssetFragment
        }
      }
      url
    }
  }
  ... on relatedGalleries_Entry {
    id
    headline
    typeHandle
    relatedGalleries {
      ... on galleries_Entry {
        displayTitle
        slug
        uri
        featureImage {
          ...AssetFragment
        }
      }
      url
    }
  }
  ... on personGroup_Entry {
    id
    typeHandle
    fullName
    position
    profilePicture {
      ...AssetFragment
    }
    description
    email
    linkedinProfile
  }
  ... on MediaBlockGroup_Entry {
    id
    typeHandle
    image {
      ...AssetFragment
    }
    imageAspectRatio
    titleText
    summaryText
    linkText
    customUrl
    popUpModalContent
    showPlaceholderImage
    truncateText
  }
  ... on imageGroup_Entry {
    id
    typeHandle
    image {
      ...AssetFragment
    }
    aspectRatio
  }
  ... on download_Entry {
    id
    typeHandle
    file {
      url
      title
    }
    customFeatureImage {
      ...AssetFragment
    }
  }
  ... on twoColumn_Entry {
    id
    typeHandle
    twoColumnRichText
    twoColumnRichText2
  }
  ... on button_Entry {
    id
    typeHandle
    buttonText
    entryLink {
      url
    }
    customUrl
    position
    style
  }
  ... on richText_Entry {
    id
    richText
    typeHandle
  }
  ... on heading_Entry {
    id
    text
    size
    typeHandle
  }
  ... on lead_Entry {
    id
    text
    typeHandle
  }
  ... on quote_Entry {
    id
    style
    quote
    attribution
    typeHandle
  }
  ... on image_Entry {
    id
    image {
      ...AssetFragment
    }
    position
    width
    typeHandle
    imageLink
  }
  ... on imageCarousel_Entry {
    id
    images {
      ...AssetFragment
    }
    aspectRatio
    typeHandle
  }
  ... on embed_Entry {
    id
    embed {
      code
      providerName
      providerUrl
      aspectRatio
      height
      width
    }
    typeHandle
  }
  ... on offices2_Entry {
    id
    typeHandle
    relatedOffice {
      ... on offices_Entry {
        title
        id
        officeSwitchboard
        officePhysicalAddress
        officePostalAddress
        officeRelatedContact {
          ... on staff_Entry {
            displayTitle
            slug
            position
            email
            featureImage {
              ...AssetFragment
            }
          }
        }
        officeEmail
        officeMap {
          url
          code
          providerName
          providerUrl
          aspectRatio
          height
          width
        }
      }
    }
  }
  ... on relatedCard_Entry {
    id
    typeHandle
    align
    relatedEntry {
      ... on staff_Entry {
        sectionHandle
        displayTitle
        slug
        uri
        position
        featureImage {
          ...AssetFragment
        }
      }
      ... on news_Entry {
        sectionHandle
        slug
        uri
        displayTitle
        summary
        featureImage {
          ...AssetFragment
        }
      }
      ... on projects_Entry {
        sectionHandle
        displayTitle
        title
        summary
        uri
        featureImage {
          ...AssetFragment
        }
        url
      }
      ... on resources_Entry {
        sectionHandle
        displayTitle
        uri
        summary
        featureImage {
          ...AssetFragment
        }
      }
      ... on page_Entry {
        sectionHandle
        displayTitle
        uri
        summary
        featureImage {
          ...AssetFragment
        }
      }
    }
  }
  ... on relatedTeamMembersVideos_Entry {
    id
    headline
    typeHandle
    featuredTeamMembers {
      ... on staff_Entry {
        displayTitle
        slug
        position
        featureImage {
          ...AssetFragment
        }
        staffCareersVideo {
          title
          url
          aspectRatio
        }
      }
      url
    }
  }
  ... on horizontalRule_Entry {
    id
    typeHandle
    horizontalRuleType
  }
  ... on logoStrip_Entry {
    id
    typeHandle
    images {
      ...AssetFragment
    }
  }
  ... on sslnDocuments2_Entry {
    id
    typeHandle
  }
  ... on agywAccordions_Entry {
    id
    typeHandle
    columnImages {
      ...AssetFragment
    }
    columnOneHeading
    colunmOneQuestionOne
    columnOneTextOne
    colunmOneQuestionTwo
    colunmOneTextTwo
    colunmOneQuestionThree
    colunmOneTextThree
    columnTwoHeading
    colunmTwoQuestionOne
    colunmTwoTextOne
    colunmTwoQuestionTwo
    colunmTwoTextTwo
    columnThreeHeading
    colunmThreeQuestionOne
    colunmThreeTextOne
    colunmThreeQuestionTwo
    colunmThreeTextTwo
    colunmThreeQuestionThree
    colunmThreeTextThree
  }
  ... on sadaMultiPopUpImage_Entry {
    id
    typeHandle
    image {
      ...AssetFragment
    }
    popUp1Heading
    popUp1RichText
    popUp2Heading
    popUp2RichText
    popUp3Heading
    popUp3RichText
    popUp4Heading
    popUp4RichText
    popUp5Heading
    popUp5RichText
    popUp6Heading
    popUp6RichText
  }
  ... on brochure_Entry {
    id
    typeHandle
    brochure {
      url
      title
      size
      height
      kind
      width
    }
    brochureLink
  }
  ... on videoAndBrochures_Entry {
    id
    typeHandle
    whatWeDoFeatureVideo {
      title
      url
      aspectRatio
    }
    whatWeDoFeatureBrochure {
      url
      title
      size
      height
      kind
      width
    }
    whatWeDoBrochureLink
    whatWeDoBrochureCaption
    whatWeDoBrochureAspectRatio
    whatWeDoFeatureBrochure2 {
      url
      title
      size
      height
      kind
      width
    }
    whatWeDoBrochureLink2
    whatWeDoBrochureCapton2
    whatWeDoBrochureAspectRatio2
  }
  ... on cardGrid_Entry {
    id
    typeHandle
    heading
    intro
    imageStyle
    cardsPerRow
    cards {
      ... on cardGridCard_Entry {
        id
        image {
          ...AssetFragment
        }
        heading
        body
      }
    }
  }
}
`;

export const ADDITIONAL_INFO_CONTENT_FRAGMENT = gql
`
    fragment AdditionalInfoContentFragment on whatWeDoAdditionalInfo_MatrixField {
  ... on richText2_Entry {
    id
    richText
    typeHandle
  }
  ... on image2_Entry {
    id
    image {
      ...AssetFragment
    }
    position
    width
    typeHandle
    imageLink
  }
  ... on cardGrid_Entry {
    id
    typeHandle
    heading
    intro
    imageStyle
    cardsPerRow
    cards {
      ... on cardGridCard_Entry {
        id
        image {
          ...AssetFragment
        }
        heading
        body
      }
    }
  }
}
`;
